/** Routes for front-end. */
export const uiRoute = '/';

/** Base route for LTI demo. */
export const sampleLtiRoute = `${uiRoute}host/lti/`;

export const UiRoutes = {
  /** Sample host page (requires sample host!) */
  SAMPLE_HOME: `${uiRoute}host/sample`,
  /** Sample host page showing individual authentication. */
  SAMPLES: `${uiRoute}host/sample/:auth`,
  /** Embed using sample credentials. */
  SAMPLE_EMBED: `${uiRoute}host/sample/embed`,
  /** Route to embed an open access critique view. */
  SAMPLE_OPEN_ACCESS: `${uiRoute}host/sample/open_access/:id`,
  /** Handoff launch endpoint (challenge, code, embed). */
  HANDOFF: `${uiRoute}go/:action/:arg`,

  RUBRIC: `${uiRoute}rubric/:action/:arg`,
  VIEW_RUBRIC: `${uiRoute}viewRubric/:action/:arg`,
  EDIT_RUBRIC: `${uiRoute}editRubric/:action/:arg`,

  /** Moderation hub */
  MODERATION_HUB: `${uiRoute}moderationHub/:action/:arg`,
  /** Trial view. */
  TRIAL: `${uiRoute}trial`,

  /** Admin view. */
  ADMIN: `${uiRoute}admin`,

  /** Get a sample LTI launch token. */
  SAMPLE_LTI_FRAME: `${sampleLtiRoute}frame`,
  /** Launch route to receive the LTI launch. */
  SAMPLE_LTI_LAUNCH: `${sampleLtiRoute}launch/:ltiAction/:role`,
  /** Page that shows the controls for triggering an OIDC login request. */
  SAMPLE_LTI_LOGIN_REQUEST: `${sampleLtiRoute}login_request/:ltiAction/:role`,
  /** Page to test device-specific issues. */
  SAMPLE_DEVICE_ISSUES: `${uiRoute}host/issues`
};

/**
 * Actions for Handoff routes (see UiRoutes).
 * Handoff is also used to redirect an LTI signin after the OIDC cycle.
 */
export enum HandoffAction {
  /** Handoff using QR code and code challenge. */
  Challenge = 'challenge',
  /** Handoff to critique using code only. */
  Code = 'code',
  /** Handoff to embedded viewer using code only. */
  Embed = 'embed',
  /** Handoff to LTI Deep Linking Request. */
  Linking = 'linking',
  /** LTI Resource list view to show (individuals') instances linked to the resource. */
  ResourceList = 'resource-list',
  /** Moderation hub */
  ModerationHub = 'moderation-hub',
  /** Tool's home page */
  Home = 'home'
}

export enum RubricAction {
  /** Manage Rubric */
  ManageRubric = 'manageRubric',
  /** Create Rubric */
  CreateRubric = 'createRubric',
  /** View Rubric */
  ViewRubric = 'viewRubric',
  /** Edit Rubric */
  EditRubric = 'editRubric',
  /** Duplicate Rubric */
  DuplicateRubric = 'duplicateRubric',
  /** Delete Rubric */
  DeleteRubric = 'deleteRubric'
}
